'use client'

import { setFavoriteLanguage } from '@/api/v2/mutations/favorite-language'
import { CascadeBack } from '@/components/design-system/cascade'
import ChevronLeftIcon from '@/components/icons/chevron-left'
import { languages } from '@/constants/languages'
import useAuth from '@/hooks/use-auth'
import { usePathname, useRouter } from '@/navigation'
import { useMutation } from '@tanstack/react-query'
import clsx from 'clsx'
import { useLocale } from 'next-intl'
import './language-panel.scss'

export default function LanguagePanel() {
  const { isAuthenticated } = useAuth()
  const locale = useLocale()
  const pathname = usePathname()
  const router = useRouter()

  const { mutate } = useMutation(
    (language: string) => setFavoriteLanguage(language),
    {
      onSettled: (data, error, variables) => {
        router.push(pathname, { locale: variables })
      },
    }
  )

  const sendFavoriteLanguage = (language: string) => {
    if (isAuthenticated) {
      mutate(language)
    } else {
      router.push(pathname, { locale: language })
    }
  }

  return (
    <div className='language-panel'>
      <header className='language-panel__header'>
        <CascadeBack className='language-panel__back'>
          <ChevronLeftIcon />
          Back
        </CascadeBack>
      </header>

      <div className='language-panel__content'>
        <ul className='language-panel__list'>
          {languages.map(({ value, label }) => (
            <li
              key={value}
              className={clsx(
                'language-panel__link',
                locale === value && `language-panel__link--active`
              )}
              onClick={() => sendFavoriteLanguage(value)}
            >
              {label}
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}
